// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3Yk6J","content":"RecentSearches_content__jMuMY"};